import { APIServiceRequestParamsInterface } from '@hrms/common/service/api/types';

export interface ReportListReqType extends APIServiceRequestParamsInterface {
  pageNo: number;
  pageSize: number;
}
export interface ReportListResp {
  hasNext: boolean;
  count: number;
  jobList: JobList[];
}

export interface JobList {
  useCase: string;
  storeId: string;
  userId: string;
  id: string;
  status: ReportsStatus;
  createdOn: string;
  updatedOn: string;
  metadata: any;
  remarks: string;
  fileUploadUrl: string;
  fileDownloadUrl: string;
}

export enum ReportsStatus {
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  INITIATED = 'INITIATED',
  NEW = 'NEW',
  CANCELLED = 'CANCELLED',
  IN_PROGRESS = 'IN_PROGRESS',
  PARTIALLY_COMPLETED = 'PARTIALLY_COMPLETED',
}
